export default {
    result: {
        type: 'Taper: ',
    },
    results: {
        count: 'résultats',
    },
    search: {
        introTitle: 'Vérifiez si votre nom apparaît déjà',
        boipNoResults: 'Aucun résultat n\'a été trouvé pour TERM dans le registre des marques de l\'OBPI',
        boipResultsTitle: 'Registre des marques de l\'OBPI',
        boipAllResults: 'Afficher tous les résultats',
        boipOneResult: 'Voir résultat',
        resultCount: 'résultats pour: ‘TERM’',
        kvkNoResults: 'Aucun résultat n\'a été trouvé pour TERM dans le registre du commerce de la chambre de commerce',
        kvkResultsTitle: 'Registre du Commerce de la Chambre de Commerce',
        kvkAllResults: 'Afficher tous les résultats',
        kvkOneResult: 'Voir résultat',
    },
    searchBox: {
        inputPlaceholder: 'Recherche dans le registre du commerce de la Chambre de commerce et le registre des marques de l\'OBPI',
        buttonLabel: 'Recherche',
    },
    infoButton: {
        kvkButton: 'Informations sur le nom commercial',
        boipButton: 'Informations sur la marque',
    },
    tradeMark: {
        applicationNumber: 'Numéro de dépôt',
        depotDate: 'Date de dépôt',
        goodsAndServices: 'Produits et services',
        goodsAndServicesPrefix: 'Cl',
    },
};
